<igx-card elevated>
    <igx-card-header>
        <h3 igxCardHeaderTitle>{{ program?.name }}</h3>
    </igx-card-header>
    <igx-grid [data]="discounts() | sorting" width="600px" height="400px">
        <igx-grid-toolbar>
            <igx-grid-toolbar-actions>
                <button igxButton igxRipple (click)="addDiscount(dialog)">Добави отстъпка</button>
            </igx-grid-toolbar-actions>
        </igx-grid-toolbar>
        <igx-column width="50px" [editable]="false" [resizable]="false" [pinned]="true">
            <ng-template igxCell let-cell="cell">
                <button title="Редактирай" igxIconButton="flat" (click)="updateDiscount(dialog, cell)">
                    <igx-icon>edit</igx-icon>
                </button>
            </ng-template>
        </igx-column>
        <igx-column field="conditionType" header="Вид" width="200px">
            <ng-template igxCell let-cell="cell">
                {{ parseConditionType(cell) }}
            </ng-template>
        </igx-column>
        <igx-column field="value" header="Стойност" dataType="number" width="90px">
            <ng-template igxCell let-value>
                {{ value/100 | percent }}
            </ng-template>
        </igx-column>
        <igx-column field="description" header="Описание"></igx-column>
        <igx-column field="summable" header="Сумируема :)" dataType="boolean" width="110px"></igx-column>
    </igx-grid>
</igx-card>
<igx-dialog #dialog>
    <igx-dialog-title>{{ dialogText }} отстъпка</igx-dialog-title>
    <form [formGroup]="discountForm" (ngSubmit)="discountSubmit()">
        <igx-input-group type="border">
            <label igxLabel>Стойност</label>
            <input igxInput [igxTextSelection]="true" type="number" name="value" formControlName="value" />
            <igx-suffix>%</igx-suffix>
        </igx-input-group>
        <igx-input-group type="border">
            <label igxLabel>Описание</label>
            <input igxInput [igxTextSelection]="true" name="description" formControlName="description" />
        </igx-input-group>
        <igx-select formControlName="conditionType">
            <label igxLabel>Условие</label>
            <igx-select-item [value]="0">Винаги</igx-select-item>
            <igx-select-item [value]="1">Преди дата</igx-select-item>
            <igx-select-item [value]="2">Приятел</igx-select-item>
            <igx-select-item [value]="3">Роднина</igx-select-item>
            <igx-select-item [value]="4">Стар клиент</igx-select-item>
        </igx-select>
        <igx-date-picker name="date" formControlName="date" *ngIf="discountForm.controls.conditionType.value === 1">
        </igx-date-picker>
        <igx-checkbox name="summable" formControlName="summable" type="border">Сумируема :)</igx-checkbox>
        <igx-dialog-actions>
            <button igxButton type="button" (click)="closeDialog(dialog)">ОТКАЖИ</button>
            <button [disabled]="!discountForm.valid" igxButton type="submit">{{ dialogText }}</button>
        </igx-dialog-actions>
    </form>
</igx-dialog>